import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { CountryState } from "../../models/mp-common/country-state";

const initialState: CountryState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.countries.getApi, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.countries.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(MpCommonActions.countries.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function countryReducer(state: CountryState | undefined, action: Action): CountryState {
	return reducer(state, action);
}
